jQuery(document).ready(function($) {
  $(window).resize(function(){
    $('.logo-slider').each((index, ele) => {
      $(ele).find('.logo-slider--wrapper').slick({
        arrows: false,
        speed: 300,
        autoplay: false,
        infinite: false,
        autoplaySpeed: 2000,
        slidesToShow: 3,

        responsive: [
          {
            breakpoint: 769,
            settings: {
              arrows: true,
              infinite: true,
              slidesToShow: $(ele).data('mobile-slide-count'),
              prevArrow: $(ele).find('.slideshow__arrow--prev'),
              nextArrow: $(ele).find('.slideshow__arrow--next'),
            }
          }
        ]
      });
    });
  });
  $('.btn-custom-dropdown').click(function (e) {
    $('.btn-custom-dropdown').not(this).removeClass('is--active');
    $(this).toggleClass('is--active');
    e.stopPropagation()
  });
  $(document).on("click", function (e) {
    if ($(e.target).is(".popout-list") === false) {
      $('.btn-custom-dropdown').removeClass('is--active');
    }
  });
 

  $('.index-reviews').each((index, ele) => {
    $(ele).find('.index-reviews--wrapper').slick({
      arrows: true,
      dots: true,
      speed: 300,
      autoplay: true,
      autoplaySpeed: 3500,
      slidesToShow: $(ele).data('desktop-slide-count'),
      prevArrow: $(ele).find('.slideshow__arrow--prev'),
      nextArrow: $(ele).find('.slideshow__arrow--next'),
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: $(ele).data('mobile-slide-count'),
            centerMode: true,
            centerPadding: '10%'
          }
        }
      ]
    });
  });
  
  $('.product-tabs--headings .product-tabs--heading').on('click', function(e) {
    let index = $(this).data('index');
    $(this).closest('.product-tabs').find('.active').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.product-tabs').find(`.product-tabs--content[data-index=${index}]`).addClass('active');
  });

  $('.marquee').marquee({
    //duration in milliseconds of the marquee
    duration: 15000,
    //gap in pixels between the tickers
    gap: 50,
    //time in milliseconds before the marquee will start animating
    delayBeforeStart: 0,
    //'left' or 'right'
    direction: 'left',
    //true or false - should the marquee be duplicated to show an effect of continues flow
    duplicated: true
  });

  
 if($(window).width() >= 991) { 
$('.slick-dots').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical:true,
    dots: false,
    infinite: false,
    focusOnSelect: true,
  verticalSwiping:true,
});
 }
  
  $('.toggle-menus').click(function(){
    $('#NavMenus').slideToggle();
  });

  $(".active-ingredient-item__btn .collapsed").click(function(event){
    event.preventDefault();
    $('.active-ingredient-item').removeClass('is--active');
    $(this).parent('.active-ingredient-item__btn').parent('.active-ingredient-item').addClass("is--active");
  });
  $(".active-ingredient-item__btn .expanded").click(function(event){
    event.preventDefault();
    $('.active-ingredient-item').removeClass('is--active');
    $(this).parent('.active-ingredient-item__btn').parent('.active-ingredient-item').removeClass("is--active");
  });

  var klaviyoContainer = $('.klaviyo-form-UCpA3j');
  var formInitialized = false;
  var downloaded = false;
  var embedForm = null;

  klaviyoContainer.bind('DOMSubtreeModified', function(){
    embedForm = klaviyoContainer.find('form');
    formButtons = klaviyoContainer.find('button');
    if (embedForm.length && !formInitialized) {
      formInitialized = true;
    }

    if (formButtons.length == 0 && formInitialized && !downloaded) {
      downloaded = true;
      startPdfDownload();
    }
  });

  function startPdfDownload(name = 'Breast Feeding Care Guide.pdf', type = 'application/octetstream') {
    // Online file link
    const url = "https://cdn.shopify.com/s/files/1/0005/7560/2806/files/Breast_Feeding_Care_Guide_Final_Draft.pdf?v=1628065099";

    // Create XMLHTTP Request.
    var req = new XMLHttpRequest();
    req.open("GET", url, true);
    req.responseType = "blob";
    req.onload = function () {
      const blob = new Blob([req.response], { type: type });

      const { URL: { createObjectURL, revokeObjectURL }, setTimeout } = window
      link = createObjectURL(blob);

      // Create download anchor
      const a = document.createElement("a");
      a.setAttribute("download", name);
      a.setAttribute("href", link);
      document.body.appendChild(a);
      a.click();

      setTimeout(() => { revokeObjectURL(url) }, 100)
      document.body.removeChild(a);
    };
    req.send();
  }


});
